import React, { useCallback, useState, useEffect } from 'react';
import axios from 'axios';
import { config } from '../../constants/config'
import { Button, Grid, Label, TextArea, Form } from 'semantic-ui-react';
import { AuthStdFooter } from '../../utils/auth-std-footer';
import '../../styles/article.css';

// Example working queries
// Can you remove the incorrect EOLs of the following text and reconnect the parts of a sentence which should be connected, " +
// "doing a carriage return only at ends of paragraphs? " +
// "Also, remove any line that starts with Fouth and ends with page number and replace it with an EOL, " +
// "Omit the response commentary. Use the following text: "


//"Could you please identify all unique characters in the following text, " +
// "separate their dialogues with a newline, " +
// "then opening([~) and closing(]) markup brackets containing their name and the text emotion, count the instances of each character's dialogue, " +
// "and finally within a separate markup [~SUMMARY, details] provide a summary of unique characters detected, their final count of dialogues, and overall emotion variations at the end of the text? " +
// "Also, try to identify the headings in line. If a heading is found prepend [~Narrator, HEADING] to the immediately following text block." +
// "Omit the response commentary. Use the following text: "

const AIQueryEditor = () => {
  const [queries, setQueries] = useState({
    paraQuery: '',
    initialParaQuery: '',
    charQuery: '',
    initialCharQuery: ''
  });

  const [paraQueryObj, setParaQueryObj] = useState(null)
  const [charQueryObj, setCharQueryObj] = useState(null)

  const extractByName = (arr, name) => { return arr.filter(item => item.name === name); };

  const fetchAIQuery = useCallback(async () => {
    try {
      const response = await axios.get(config.API_GET_AI_QUERIES);
      const paraQueryEntries = extractByName(response.data.queries, 'paraQuery')[0];
      const charQueryEntries = extractByName(response.data.queries, 'charQuery')[0];
      setParaQueryObj(paraQueryEntries)
      setCharQueryObj(charQueryEntries)

      setQueries({
        paraQuery: paraQueryEntries.query,
        initialParaQuery: paraQueryEntries.query,
        charQuery: charQueryEntries.query,
        initialCharQuery: charQueryEntries.query
      });
    } catch (error) {
      console.error('Error fetching paraQuery:', error);
      setQueries({
        initialParaQuery: "No Paragraph Query",
        paraQuery: "No Paragraph Query",
        charQuery: "No Character Query",
        initialCharQuery: "No Character Query"
      });
    }
  }, []);


  useEffect(() => {
    fetchAIQuery();
  }, [fetchAIQuery]);

  const handleTextAreaChange = (e, key) => {
    setQueries(prevState => ({
      ...prevState,
      [key]: e.target.value
    }));
  };

  const handleSave = async (e, key, queryObj) => {
    e.preventDefault();
    try {
      const saveObj = { ...queryObj, query: queries[key] };
      const response = await axios.post(config.API_SAVE_AI_QUERY, { saveObj });
      console.log(response.data);
      fetchAIQuery();
    } catch (error) {
      console.error(`Error saving ${key}:`, error);
    }
  };

  const handleReset = (key, initialKey) => {
    setQueries(prevState => ({
      ...prevState,
      [key]: prevState[initialKey]
    }));
  };


  return (
    <>
      <Form>
        <div style={{ maxWidth: "1024px" }}>
          <Grid>
            <Grid.Row>
              <Grid.Column width={5}>
                <span className="listTitle" style={{ display: "block", width: "1024px", marginBottom: "-15px" }}>
                  {"AI Query Editor"}
                </span>
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={12}>
                <Label className='dashMenuItemLabel'>Import Formatting Correction Query (paragraph format corrections)</Label>
                <TextArea
                  style={{ minHeight: 200, width: "100%" }}
                  placeholder='Standard Paragraph chatGPT Query'
                  value={queries.paraQuery}
                  onChange={(e) => handleTextAreaChange(e, 'paraQuery')}
                />
              </Grid.Column>
              <Grid.Column className="noMarginLeft" width={2}>
                <Button basic content='Reset' style={{ width: "100%" }} onClick={() => handleReset('paraQuery', 'initialParaQuery')} />
              </Grid.Column>
              <Grid.Column className="noLeftPad" width={2}>
                <Button basic content='Save' type="button" onClick={(e) => handleSave(e, 'paraQuery', paraQueryObj)} style={{ width: "100%" }} />
              </Grid.Column>
            </Grid.Row>
          </Grid>
          <Grid>
            <Grid.Row>
              <Grid.Column width={12}>
                <Label className='dashMenuItemLabel'>Analyze Story Text</Label>
                <TextArea
                  style={{ minHeight: 200, width: "100%" }}
                  placeholder='Standard Character chatGPT Query'
                  value={queries.charQuery}
                  onChange={(e) => handleTextAreaChange(e, 'charQuery')}
                />
              </Grid.Column>
              <Grid.Column className="noMarginLeft" width={2}>
                <Button basic content='Reset' style={{ width: "100%" }} onClick={() => handleReset('charQuery', 'initialCharQuery')} />
              </Grid.Column>
              <Grid.Column className="noLeftPad" width={2}>
                <Button basic content='Save' type="button" onClick={(e) => handleSave(e, 'charQuery', charQueryObj)} style={{ width: "100%" }} />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </div>
      </Form>
      {AuthStdFooter()}
    </>
  );
}

export default AIQueryEditor;
